import { render, staticRenderFns } from "./veHqChurukuErcode.vue?vue&type=template&id=4eeffa1a&scoped=true"
import script from "./veHqChurukuErcode.vue?vue&type=script&lang=js"
export * from "./veHqChurukuErcode.vue?vue&type=script&lang=js"
import style0 from "./veHqChurukuErcode.vue?vue&type=style&index=0&id=4eeffa1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeffa1a",
  null
  
)

export default component.exports